var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":require("@/assets/images/spinner.gif"),"width":_vm.size,"height":_vm.size}}),_c('h3',[_vm._v("Loading...")])])}
var staticRenderFns = []

export { render, staticRenderFns }